import { AuthComponent } from "./modules/framework/auth/auth.component";
import { StarterComponent } from "./modules/framework/starter/starter.component";
import { ClientSelectionComponent } from "./modules/framework/client-selection/client-selection.component";
import { AuthGuard } from "./guards";
// Layouts laden
import { BlankLayoutComponent } from "./layouts/blankLayout.component";
import { BasicLayoutComponent } from "./layouts/basicLayout.component";
// Komponente fuer Inhalte importieren
import { ListingComponent } from "./modules/content/listing/listing.component";
import { DetailComponent } from "./modules/content/detail/detail.component";
import { StandaloneDetailResolver } from "./services/details/standalonedetail.resolver";
import { NavigationGuard } from "./guards/navigation.guards";
import { ErrorGuard } from "./guards/error.guards";
import { ForgotComponent } from "./modules/framework/password/forgot.component";
import { ResetComponent } from "./modules/framework/password/reset.component";
import { ListingConfigurationResolver } from "./services/listing/listing-configuration.resolver";
import { ListingContentsResolver } from "./services/listing/listing-contents.resolver";
import { DetailResolver } from "./services/details/detail.resolver";
import { ErrorloginComponent } from './modules/framework/errorlogin/errorlogin.component';
import { ConfigGuards } from './guards/config.guards';
import { AuthResolver } from "./services/authentication/auth.resolver";
import { UnsavedChangesGuard } from "./guards/unsaved-changes.guard";
import { ClientSelectionResolver } from "./services/client-selection/client-selection.resolver";
import { ReducedDetailComponent } from "./modules/content/reduced-detail/reduced-detail.component";
import { ProfileResolver } from "./services/details/profile.resolver";
import { CompanyLookupComponent } from "./modules/content/company-lookup/company-lookup.component";
const ɵ0 = { nested_listing: true }, ɵ1 = { nested_listing: true }, ɵ2 = { nested_listing: true }, ɵ3 = { nested_listing: true };
// Datenfeld mit Routen-Konfigurationen
// The router uses a first-match wins strategy when matching routes
export const ARR_ROUTES = [
    // Main redirect
    {
        path: "",
        redirectTo: "starter",
        pathMatch: "full"
    },
    {
        path: "",
        component: BlankLayoutComponent,
        children: [
            {
                path: "errorlogin",
                component: ErrorloginComponent,
                canActivate: [ErrorGuard]
            },
            {
                path: "login",
                component: AuthComponent,
                resolve: {
                    BOO_autologin: AuthResolver
                },
                canActivate: [ConfigGuards]
            },
            {
                path: "password-forgot",
                component: ForgotComponent,
                canActivate: [ConfigGuards]
            },
            {
                path: "set-new-password/:token",
                component: ResetComponent,
                canActivate: [ConfigGuards]
            },
            {
                path: "client-selection",
                component: ClientSelectionComponent,
                resolve: {
                    OBJ_current_user: ClientSelectionResolver
                },
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: "",
        component: BasicLayoutComponent,
        children: [
            // Startseite
            {
                path: "starter",
                component: StarterComponent
            }
        ],
        canActivate: [
            AuthGuard,
            NavigationGuard
        ]
    },
    {
        path: "profile",
        component: BasicLayoutComponent,
        children: [
            {
                path: "users",
                component: DetailComponent,
                resolve: {
                    OBJ_detail_config: ProfileResolver
                },
                canDeactivate: [UnsavedChangesGuard],
                // Nach jedem navigieren zu der URL Daten neu initialisieren, um auch nach save reload zu ermoeglichen
                runGuardsAndResolvers: 'always'
            },
        ]
    },
    {
        path: ":route_menu",
        component: BasicLayoutComponent,
        children: [
            {
                // Liste die bei Klick auf Liste weiterfuehrt
                path: "listing/:route_submenu",
                component: ListingComponent,
                resolve: {
                    OBJ_contents_helper: ListingContentsResolver,
                    OBJ_config: ListingConfigurationResolver
                },
                data: ɵ0
            },
            {
                // Liste in Liste
                path: "listing/:route_submenu/new",
                component: DetailComponent,
                resolve: {
                    OBJ_detail_config: DetailResolver
                },
                canDeactivate: [UnsavedChangesGuard],
                // Nach jedem navigierne zu der URL Daten neu initialisieren, um auch nach save reload zu ermoeglichen
                runGuardsAndResolvers: 'always',
                data: ɵ1
            },
            {
                // Liste in Liste
                path: "listing/:route_submenu/:listing_id",
                component: ListingComponent,
                resolve: {
                    OBJ_contents_helper: ListingContentsResolver,
                    OBJ_config: ListingConfigurationResolver
                },
                data: ɵ2
            },
            {
                path: "listing/:route_submenu/:listing_id/:id",
                component: DetailComponent,
                resolve: {
                    OBJ_detail_config: DetailResolver
                },
                canDeactivate: [UnsavedChangesGuard],
                // Nach jedem navigieren zu der URL Daten neu initialisieren, um auch nach save reload zu ermoeglichen
                runGuardsAndResolvers: 'always',
                data: ɵ3
            },
            {
                // Listenansicht
                path: ":route_submenu",
                component: ListingComponent,
                resolve: {
                    OBJ_contents_helper: ListingContentsResolver,
                    OBJ_config: ListingConfigurationResolver
                }
            },
            {
                // Reduzierte Detailansicht von Ressourcen, die keine Listenansicht haben
                path: ":route_submenu/reduceddetail",
                component: ReducedDetailComponent,
                resolve: {
                    OBJ_detail_config: StandaloneDetailResolver
                },
                // Nach jedem navigieren zu der URL Daten neu initialisieren, um auch nach save reload zu ermoeglichen
                runGuardsAndResolvers: 'always'
            },
            {
                // Detailansicht von Ressourcen, die keine Listenansicht haben
                path: ":route_submenu/detail/:id",
                component: DetailComponent,
                resolve: {
                    OBJ_detail_config: StandaloneDetailResolver
                },
                canDeactivate: [UnsavedChangesGuard],
                // Nach jedem navigierne zu der URL Daten neu initialisieren, um auch nach save reload zu ermoeglichen
                runGuardsAndResolvers: 'always'
            },
            {
                path: "companies/new",
                component: CompanyLookupComponent,
                runGuardsAndResolvers: "always"
            },
            {
                path: ":route_submenu/:id",
                component: DetailComponent,
                resolve: {
                    OBJ_detail_config: DetailResolver
                },
                canDeactivate: [UnsavedChangesGuard],
                // Nach jedem navigierne zu der URL Daten neu initialisieren, um auch nach save reload zu ermoeglichen
                runGuardsAndResolvers: 'always'
            },
            {
                // Detailansicht von externen iFrames, die WCMS Speicherbutton etc. nicht benoetigen
                path: ":route_submenu/reduced/:id",
                component: ReducedDetailComponent,
                resolve: {
                    OBJ_detail_config: DetailResolver
                },
                // Nach jedem navigieren zu der URL Daten neu initialisieren, um auch nach save reload zu ermoeglichen
                runGuardsAndResolvers: 'always'
            },
        ],
        canActivate: [
            AuthGuard,
            NavigationGuard
        ]
    },
    // Handle all other routes
    // The ** path in the last route is a wildcard. The router will select this route if the requested URL doesn"t match any paths for routes defined earlier
    // in the configuration. This is useful for displaying a "404 - Not Found" page or redirecting to another route.
    {
        path: "**",
        redirectTo: "starter",
        canActivate: [
            AuthGuard,
            NavigationGuard
        ]
    },
];
export { ɵ0, ɵ1, ɵ2, ɵ3 };
